import {
    Accordion,
    AccordionDetails,
    Button,
    Chip,
    Grid2,
    InputAdornment,
    TextField,
    Typography,
} from "@mui/material";
import log from "loglevel";
import React, { useEffect, useState } from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ModeEditOutlineIcon from "@mui/icons-material/ModeEditOutline";
import PostAddIcon from "@mui/icons-material/PostAdd";
import QueueOutlinedIcon from "@mui/icons-material/QueueOutlined";
import { AccordionSummary } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import { makeStyles } from "@mui/styles";
import AtsTooltip from "components/common/AtsTooltip";
import TagChip from "components/common/TagChip";
import TextAreaEditor from "components/common/TextAreaEditor";
import { FilmCardView } from "components/film/index";
import { RelatedTable } from "components/relatedFilms";
import { actions as reportAdvActions } from "components/report/advertising/logic/advReportActions";
import { actions as reportLogActions } from "components/report/logsheet/logic/logReportActions";
import { ATTRIBUTE_TYPES } from "core/dataConstants";
import { get } from "lodash";
import { connect, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { API_URL } from "services";
import { ContactChip } from "../../common/Contacts";
import {
    AddNewAdvFromExisting,
    AdvExpandHeader,
    DeleteAdvBtn,
    ReviewExpandHeader,
    StatusIcon,
} from "../commonComponents";
import { actions } from "../logic/formActions";
import { styles } from "./styles";
import "./styles.scss";
import AccordionActions from "@mui/material/AccordionActions";
import { formatDate, DATE_FORMAT_ZONE_TIME_LONG, DATE_FORMAT_FULL_INPUT } from "components/common/dateUtils";
import { currentUserSelector } from "../../login/logic/actions";
import { isReadOnlyRole } from "../../login/logic/sagas";
function sortReviewDesc(a, b) {
    if (a.dateEntered > b.dateEntered) return -1;
    else if (a.dateEntered < b.dateEntered) return 1;
    return 0;
}

const useStyles = makeStyles(styles);

const AdvDetails = (props) => {
    const { adv, detailsReviewSelected, filmCodeTypes, addToReport, addToLogReport } = props;
    const [associations, setAssociations] = useState(adv ? adv.associations : []);
    let navigate = useNavigate();
    const classes = useStyles();
    const user = useSelector(currentUserSelector);
    const [reviewSelected, setReviewSelected] = useState(null);
    let { id } = useParams();
    useEffect(() => {
        props.loadAdv(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    useEffect(() => {
        log.debug("adv changed");
        setReviewSelected(detailsReviewSelected);
    }, [detailsReviewSelected]);

    const selectReview = (index) => {
        setReviewSelected(adv.reviews[index]);
    };

    function handleOnAddToReport() {
        addToReport([adv]);
    }

    function handleOnAddLog() {
        addToLogReport([adv]);
    }

    function onAdvDeleted() {
        backToAdv();
    }

    const final = adv && adv.attributes.findIndex((item) => item.attributeType === ATTRIBUTE_TYPES.FINAL_TYPE) !== -1;
    const attrLength = adv && adv.attributes.find((attr) => attr.attributeType === ATTRIBUTE_TYPES.LENGTH);

    const attrLEQ = adv && adv.attributes.find((attr) => attr.attributeType === ATTRIBUTE_TYPES.LEQ);

    if (!adv) {
        return (
            <Backdrop className={classes.backdrop} open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        );
    }
    const content = {
        title: "Film Title",
        releaseDate: "Release Date",
        company: "Company",
        contacts: [],
    };
    const filmRelease = get(adv, "filmRelease", null);
    if (filmRelease) {
        log.debug("filmRelease");
        log.debug(filmRelease);
        content.title = filmRelease.title;
        content.releaseDate = filmRelease.releaseDate
            ? formatDate(filmRelease.releaseDate, DATE_FORMAT_ZONE_TIME_LONG)
            : formatDate(filmRelease.enteredDate, DATE_FORMAT_ZONE_TIME_LONG);
        content.company = filmRelease.companyId && filmRelease.companyId.title;
        content.releaseType = filmRelease.filmReleaseTypeId.name;
        content.ratingReason = filmRelease.ratingReason;
        content.rating = filmRelease.filmRatingTypeId.name;
        content.contacts = filmRelease.contacts;
    }

    function backToAdv() {
        navigate(-1);
    }

    const adCode = filmCodeTypes
        .filter((type) => {
            return (
                adv.advertisementCodeValues &&
                adv.advertisementCodeValues.findIndex((initType) => initType.value === type.value) !== -1
            );
        })
        .map((type) => ({ value: type.id, label: type.name }));

    const filmCode =
        adv.advertisementCodeValues &&
        adv.advertisementCodeValues.map((code) => ({
            label: code.codeValue,
            value: code.codeValue,
        }));
    const codeName = adCode && adCode.length > 0 ? adCode[0].label : null;
    const codeValue = filmCode && filmCode.length > 0 ? filmCode[0].value : null;
    const privateNotes = reviewSelected && reviewSelected.privateNote ? reviewSelected.privateNote : "";
    const instructions = reviewSelected && reviewSelected.instruction ? reviewSelected.instruction : "";

    const reviewStatusType = reviewSelected && reviewSelected.reviewStatusType;
    const deliverySystemName = get(adv, "deliverySystem.name", null);
    let showViewers = false;
    if (adv) {
        adv.reviews.map(row => {
            if (row?.viewers && row?.viewers.length > 0) {
                showViewers = true;
            }
        });
    }
    return (
        (<Grid2 container className={"adv-details"}>
            <Grid2 style={{ paddingLeft: 10, paddingBottom: 10 }} container size={12}>
                <Grid2 size={2}>
                    <Button size={"small"} startIcon={<ArrowBackIcon />} variant={"outlined"} onClick={backToAdv}>
                        Back
                    </Button>
                </Grid2>
                {!isReadOnlyRole(user) && <Grid2 style={{ textAlign: "right" }} size={10}>
                    <Button
                        size={"small"}
                        style={{ marginLeft: 5 }}
                        onClick={handleOnAddToReport}
                        startIcon={<PostAddIcon />}
                        variant={"outlined"}
                    >
                        Report
                    </Button>
                    <Button
                        size={"small"}
                        style={{ marginLeft: 5 }}
                        onClick={handleOnAddLog}
                        startIcon={<QueueOutlinedIcon />}
                        variant={"outlined"}
                    >
                        Log Sheet
                    </Button>
                    <Button
                        size={"small"}
                        style={{ marginLeft: 5 }}
                        startIcon={<ModeEditOutlineIcon />}
                        onClick={() => props.toggleAdvertisingForm(true, adv.id)}
                        variant={"outlined"}
                    >
                        Edit
                    </Button>

                    <AddNewAdvFromExisting refreshViewPage style={{ marginLeft: 5 }} advId={id} />

                    <DeleteAdvBtn
                        btnProps={{ style: { marginLeft: 5 } }}
                        advId={adv.id}
                        onAdvDeleted={onAdvDeleted}
                        advName={adv.name}
                    />
                </Grid2>}
            </Grid2>
            <Grid2 container style={{ padding: "5px  10px" }} size={12}>
                <FilmCardView
                    expandPanelClassName={"root"}
                    defaultExpanded={false}
                    loadFilmReleaseId={filmRelease.id}
                    filmRelease={filmRelease}
                />
            </Grid2>
            <Grid2 container style={{ padding: "5px  10px" }} size={12}>
                <Accordion className="root">
                    <AccordionSummary className={classes.summary} expandIcon={<ExpandMoreIcon />}>
                        <AdvExpandHeader adv={adv} final={final} attrLength={attrLength} attrLEQ={attrLEQ} />
                    </AccordionSummary>

                    <AccordionDetails>
                        <Grid2 container spacing={2}>
                            <Grid2
                                container
                                spacing={10}
                                size={{
                                    xs: 12,
                                    md: 12
                                }}>
                                <Grid2
                                    style={{ paddingTop: 0 }}
                                    size={{
                                        xs: 12,
                                        md: 6
                                    }}>
                                    <RelatedTable
                                        associations={associations}
                                        advId={adv.id}
                                        changeAssociations={setAssociations}
                                    />
                                </Grid2>
                                <Grid2
                                    container
                                    size={{
                                        xs: 12,
                                        md: 6
                                    }}>
                                    <Grid2
                                        size={{
                                            xs: 12,
                                            sm: 4,
                                            md: 4
                                        }}>
                                        <label htmlFor="name" className="labelByHand">
                                            Contact
                                        </label>
                                        {adv.contact && (
                                            <ContactChip
                                                user={{
                                                    name: `${adv.contact.firstName} ${adv.contact.lastName}`,
                                                    ...adv.contact,
                                                }}
                                                size={"medium"}
                                            />
                                        )}
                                        {!adv.contact && (
                                            <Typography style={{ color: "#606060" }}>No Contact</Typography>
                                        )}
                                    </Grid2>
                                    {(codeName || codeValue) && (
                                        <Grid2 size={{
                                            sm: 4
                                        }}>
                                            <label htmlFor="codeName" className="labelByHand">
                                                AD CODE
                                            </label>
                                            <TextField
                                                label={null}
                                                defaultValue={codeValue}
                                                variant="outlined"
                                                id="codeName"
                                                slotProps={{
                                                    input: {
                                                        startAdornment: (
                                                            <InputAdornment position="start">{codeName}</InputAdornment>
                                                        ),
                                                    }
                                                }}
                                            />
                                        </Grid2>
                                    )}
                                    { }
                                    { }
                                    { }
                                    { }
                                    { }
                                    { }
                                    { }
                                    { }
                                    { }
                                    { }
                                    { }
                                    { }
                                    { }
                                    { }
                                    { }
                                    { }
                                    { }
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </AccordionDetails>
                    {deliverySystemName && (
                        <React.Fragment>
                            <Divider />

                            <AccordionActions>
                                <Grid2 container size={12}>
                                    <Chip
                                        variant="outlined"
                                        icon={<CallReceivedIcon />}
                                        size="small"
                                        label={`Received via ${deliverySystemName}`}
                                    />
                                </Grid2>
                            </AccordionActions>
                        </React.Fragment>
                    )}
                </Accordion>
            </Grid2>
            <Grid2 className="review-section" container style={{ padding: "0  10px" }} size={12}>
                <Accordion className="root" defaultExpanded>
                    <AccordionSummary className={classes.summary} style={{ paddingLeft: 30 }} expandIcon={<ExpandMoreIcon />}>
                        {reviewSelected ? (
                            <ReviewExpandHeader
                                review={reviewSelected}
                                status={reviewStatusType}
                                dateEntered={reviewSelected.dateEntered}
                                dateModified={reviewSelected.dateEntered}
                            />
                        ) : (
                            <Typography>Review</Typography>
                        )}
                    </AccordionSummary>
                    <AccordionDetails style={{ paddingLeft: 16 }} className={classes.summary}>
                        <Grid2 paddingLeft={5}
                            size={{
                                xs: 12,
                                md: 12
                            }}>
                            <Grid2
                                container
                                size={{
                                    xs: 12,
                                    md: 12
                                }}>
                                <Grid2 container size={12}>
                                    <Grid2 container size={12} spacing={3}>
                                        {reviewSelected && (
                                            <Grid2
                                                style={{ marginBottom: 15, paddingRight: 25 }}
                                                size={{
                                                    xl: 6,
                                                    lg: 6,
                                                    xs: 12
                                                }}>
                                                <label htmlFor="instructions" className="labelByHand">
                                                    Instructions
                                                </label>

                                                <TextAreaEditor readOnly defaultValue={instructions} />
                                            </Grid2>
                                        )}
                                        {reviewSelected && (
                                            <Grid2
                                                style={{ marginBottom: 15, marginLeft: -20 }}
                                                size={{
                                                    xl: 6,
                                                    lg: 6,
                                                    xs: 12
                                                }}>
                                                <label htmlFor="privateNotes" className="labelByHand">
                                                    Private Notes
                                                </label>
                                                <TextAreaEditor readOnly defaultValue={privateNotes} />
                                            </Grid2>
                                        )}
                                        {reviewSelected && (
                                            <Grid2 container>
                                                {reviewSelected.tags && reviewSelected.tags.length > 0 && (
                                                    <Grid2 style={{ marginBottom: 15 }} size={12}>
                                                        <label htmlFor="reviewSelected" className="labelByHand">
                                                            Review Tags
                                                        </label>
                                                        <span>
                                                            {reviewSelected.tags.map((r) => {
                                                                return <TagChip key={r.id} tag={r} />;
                                                            })}
                                                        </span>
                                                    </Grid2>
                                                )}
                                                {reviewSelected.reviewMinutes && <Grid2 size={12}>
                                                    <label htmlFor="reviewSelected" className="labelByHand">
                                                        Review Time: <b>{reviewSelected.reviewMinutes} Minutes</b>
                                                    </label>
                                                </Grid2>}
                                            </Grid2>
                                        )

                                        }

                                    </Grid2>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </AccordionDetails>
                </Accordion>

                <Accordion className="root" style={{ paddingLeft: 10 }}>
                    <AccordionSummary className={classes.summary} expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="h6" style={{ fontSize: 18 }}>
                            Review history
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.summary}>
                        <Grid2 container>
                            <Grid2
                                className="table-header"
                                size={{
                                    xs: 12,
                                    md: 12
                                }}>
                                <Grid2

                                    size={{
                                        xs: 6,
                                        md: 2
                                    }}>
                                    DATE
                                </Grid2>
                                <Grid2

                                    size={{
                                        xs: 6,
                                        md: 2
                                    }}>
                                    STATUS
                                </Grid2>
                                <Grid2

                                    size={{
                                        xs: 6,
                                        md: 3
                                    }}>
                                    INSTRUCTIONS
                                </Grid2>
                                <Grid2

                                    size={{
                                        xs: 6,
                                        md: 3
                                    }}>
                                    PRIVATE NOTES
                                </Grid2>
                                {showViewers && <Grid2
                                    size={{
                                        xs: 6,
                                        md: 2
                                    }}>
                                    VIEWERS
                                </Grid2>}
                            </Grid2>
                            <Grid2
                                className="table-body"
                                size={{
                                    xs: 12,
                                    md: 12
                                }}>
                                {adv &&
                                    adv.reviews.sort(sortReviewDesc).map((row, i) => {
                                        const viewers = row?.viewers || [];
                                        return (
                                            <Grid2
                                                container
                                                key={row.id}
                                                className="table-item selectable stripe-row"
                                                onClick={() => selectReview(i)}
                                                size={{
                                                    xs: 12,
                                                    md: 12
                                                }}>
                                                <Grid2

                                                    size={{
                                                        xs: 6,
                                                        md: 2
                                                    }}>
                                                    {row.date}
                                                    <div className="f-col">
                                                        <div>{formatDate(row.dateEntered, DATE_FORMAT_FULL_INPUT)}</div>
                                                    </div>
                                                    {row.reviewer && (
                                                        <div className={"block-ellipsis-2-lines"} style={{ fontSize: 14 }}>
                                                            {`${row.reviewer.firstName} ${row.reviewer.lastName}`}
                                                        </div>
                                                    )}
                                                </Grid2>
                                                <Grid2

                                                    size={{
                                                        xs: 6,
                                                        md: 2
                                                    }}>
                                                    <div className="f-col">
                                                        {row.reviewStatusType && (
                                                            <div style={{ display: "inline-flex" }}>
                                                                <StatusIcon status={row.reviewStatusType} />
                                                                {row.reviewStatusType.name}
                                                            </div>
                                                        )}
                                                    </div>
                                                </Grid2>
                                                <Grid2

                                                    size={{
                                                        xs: 12,
                                                        md: 3
                                                    }}>
                                                    <AtsTooltip
                                                        trigger={
                                                            <Typography
                                                                style={{
                                                                    paddingRight: 5,
                                                                    width: "99%",
                                                                    fontSize: "0.9rem",
                                                                    minHeight: "100%"
                                                                }}
                                                                className={"block-ellipsis-3-lines no-padding-html-text"}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: row.instruction ? row.instruction : "",
                                                                }}
                                                            />
                                                        }
                                                        content={
                                                            <React.Fragment>
                                                                <Typography className={"bold600"}>
                                                                    Instructions:{" "}
                                                                </Typography>
                                                                <Typography
                                                                    className={"no-padding-html-text"}
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: row.instruction ? row.instruction : "",
                                                                    }}
                                                                />
                                                            </React.Fragment>
                                                        }
                                                        contentStyle={{ maxWidth: 600, maxHeight: 400, overflow: "scroll"  }}
                                                    />
                                                </Grid2>
                                                <Grid2

                                                    size={{
                                                        xs: 12,
                                                        md: 3
                                                    }}>
                                                    <AtsTooltip
                                                        trigger={
                                                            <Typography
                                                                style={{ paddingLeft: 5, width: "99%", fontSize: "0.9rem", minHeight: "100%" }}
                                                                className={"block-ellipsis-3-lines no-padding-html-text"}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: row.privateNote ? row.privateNote : "",
                                                                }}
                                                            />
                                                        }
                                                        content={
                                                            <React.Fragment>
                                                                <Typography className={"bold600"}>
                                                                    Private Notes:{" "}
                                                                </Typography>
                                                                <Typography
                                                                    className={"no-padding-html-text"}
                                                                    
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: row.privateNote ? row.privateNote : "",
                                                                    }}
                                                                />
                                                            </React.Fragment>
                                                        }
                                                        contentStyle={{ maxWidth: 600, maxHeight: 400, overflow: "scroll" }}
                                                    />
                                                </Grid2>
                                                {viewers.length > 0 && <Grid2
                                                    size={{
                                                        xs: 12,
                                                        md: 2
                                                    }}>
                                                    <AtsTooltip
                                                        trigger={
                                                            <Typography
                                                                style={{ paddingLeft: 5, width: "99%", fontSize: "0.9rem", minHeight: "100%" }}
                                                                className={"block-ellipsis-3-lines no-padding-html-text"}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: viewers.map(viewer => viewer.name ? viewer.name : "").join(", "),
                                                                }}
                                                            />
                                                        }
                                                        content={
                                                            <React.Fragment>
                                                                <Typography className={"bold600"}>
                                                                    Viewers:{" "}
                                                                </Typography>
                                                                <Typography
                                                                    className={"no-padding-html-text"}
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: viewers.map(viewer => viewer.name ? viewer.name : "").join(", "),
                                                                    }}
                                                                />
                                                            </React.Fragment>
                                                        }
                                                        contentStyle={{ maxWidth: 600, maxHeight: 400, overflow: "scroll" }}
                                                    />
                                                </Grid2>}
                                            </Grid2>
                                        );
                                    })}
                            </Grid2>
                        </Grid2>
                    </AccordionDetails>
                </Accordion>
            </Grid2>
        </Grid2>)
    );
};

const mapStateToProps = ({ advertising }) => ({
    adv: advertising.details,
    detailsReviewSelected: advertising.detailsReviewSelected,
    filmCodeTypes: advertising.filmCodeTypes,
});

const mapDispatchToProps = (dispatch) => ({
    loadAdv: (id) => dispatch(actions.VIEW_ADV.send(id)),
    toggleAdvertisingForm: (editing, id) =>
        dispatch(actions.TOGGLE_ADVERTISING_FORM.send({ editing, id, fromDetails: true })),
    getFilmCodeTypes: () => dispatch(actions.GET_FILM_CODE_TYPE.send(API_URL.filmCodeT())),
    addToReport: (adv) => dispatch(reportAdvActions.ON_ADD_ADV_TO_REPORT.send(adv)),
    addToLogReport: (adv) => dispatch(reportLogActions.ON_ADD_ADV_TO_LOG_REPORT.send(adv)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdvDetails);
